<template>
  <div :class="{loading: loading}" :style="{height: innerHeight - 68 + 'px'}">
    <section class="phone" v-if="!loading" :style="{height: innerHeight - 68 + 'px'}">
      <div class="first">Vďaka za Vaše odpovede!</div>
      <div class="second">Registrácia ZDARMA je Vám momentálne sprístupnená!</div>
      <div class="third">"Získajte týždenne 1000 €!"</div>
      <div class="enter">
        <div class="enter-text">Zadajte Vaše telefónne číslo:</div>
        <input
          type="tel"
          @input="maskCheck"
          v-model="phone"
          v-mask="{mask}"
          placeholder="+421-9__-___-___"
          class="enter__input"
        />
        <button
          class="button"
          :disabled="!done"
          @click="next"
          :class="{'button--active': done}"
        >Potvrďte účasť</button>
      </div>
    </section>
    <img src="../assets/img/loading.gif" v-if="loading" alt />
  </div>
</template>


<style lang="scss" scoped>
.phone {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 300px;
  margin: 0 auto;
  max-height: 850px;
  min-height: 412px;
}
.first {
  font-size: 16px;
  color: #b81b1e;
}
.second {
  font-weight: 500;
  font-size: 23px;
  line-height: 27px;
  text-align: center;
  text-transform: uppercase;
  color: #43a047;
}
.third {
  font-weight: bold;
  font-size: 23px;
  line-height: 28px;
  text-transform: uppercase;
  color: #000000;
}
.enter {
  &-text {
    color: #2f9e31;
    font-size: 13px;
    margin-bottom: 6px;
  }
  &__input {
    outline: none;
    background: #ffffff;
    box-shadow: inset 0px 1px 10px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    color: #000000;
    padding: 11px 14px;
    width: 100%;
    border: none;
    min-height: 49px;
    font-size: 25px;
    font-weight: 300;
    &::placeholder {
      color: #c2c2c2;
    }
  }
}
.button {
  margin-top: 49px;
  outline: none;
  background: #d9d9d9;
  border-radius: 6px;
  border: none;
  border-bottom: 2px solid #c0c0c0;
  color: #8d8d8d;
  font-weight: 500;
  font-size: 18px;
  padding: 18px 36px 15px 52px;
  width: 100%;
  position: relative;
  &::before {
    content: url("../assets/img/lock.svg");
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translate(0, calc(-50% + 2px));
  }
  &--active {
    background: #2f9e31;
    border-color: #2d862f;
    color: #ffffff;
    &::before {
      content: url("../assets/img/opened.svg");
    }
  }
}
.loading{
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 163px;
        height: 163px;
    }
}
</style>

<script>
export default {
  data: () => ({
    innerHeight: window.innerHeight,
    mask: "+421-\\999-999-999",
    phone: null,
    done: false,
    loading: false
  }),
  methods: {
    maskCheck: function(field) {
      if (field.target.inputmask.isComplete()) {
        this.done = true;
      } else {
        this.done = false;
      }
    },
    next() {
      this.loading = true;
      setTimeout(()=>{
          this.$emit('switchScreen','result')
          this.$emit('sendPhone',this.phone)
      },2700)
    }
  },
  mounted() {
    window.onresize = () => (this.innerHeight = window.innerHeight);
  }
};
</script>